

// create contaxt api for orders
import React, { useContext, createContext, useReducer } from "react";

const OrderContext = createContext();


const initialState = {
  orders: [],
  cancel_order_id: null,
  order: null,
};

const orderReducer = (state, action) => {
  switch (action.type) {
    case "GET_ORDERS":
      return { ...state, orders: action.payload };
    case "GET_ORDER_DETAIL":
      return { ...state, order: action.payload };
    case "CANCEL_ORDER":
      return { ...state, cancel_order_id: action.payload };
    default:
      return state;
  }
}


export const OrderProvider = ({ children }) => {
  // reducer
  const [state, dispatch] = useReducer(orderReducer, initialState);
  return (
    <OrderContext.Provider value={{ state, dispatch }} >
      {children}
    </OrderContext.Provider>
  );
};


export const useOrder = () => useContext(OrderContext);
